import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
export const AuthorNote = () => {
  return <section className="w-full py-20 px-6 bg-white relative" data-id="element-9">
      <div className="max-w-3xl mx-auto" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="bg-cream rounded-3xl p-8 md:p-12 shadow-soft relative" data-id="element-11">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-white p-3 rounded-full shadow-sm" data-id="element-12">
            <Heart className="w-8 h-8 text-anger fill-anger/20" data-id="element-13" />
          </div>

          <h3 className="font-display text-2xl md:text-3xl font-bold text-center text-dark mb-8 mt-4" data-id="element-14">
            Nota Personal del Autor / A Note from the Author
          </h3>

          <div className="space-y-6 font-body text-lg text-dark/80 leading-relaxed" data-id="element-15">
            <p data-id="element-16">
              Sé exactamente lo que se siente. Estás en la fila del supermercado
              o tratando de terminar una llamada de trabajo y, de repente, el
              caos. Tu hijo empieza a gritar, su cara se pone roja y parece que
              no hay palabras —ni en inglés ni en español— que puedan calmar la
              tormenta.
            </p>
            <p data-id="element-17">
              Como padres criamos en dos mundos, y a veces, nuestros hijos se
              quedan atrapados en medio, sin saber cómo nombrar el "fuego" que
              sienten por dentro. Creé este libro porque me di cuenta de que{' '}
              <strong data-id="element-18">
                el berrinche no es mala conducta; es falta de vocabulario.
              </strong>
            </p>
            <p data-id="element-19">
              Cuando un niño no puede decir "I am frustrated" o "Estoy
              frustrado", lo grita con el cuerpo. Este libro no es solo para
              colorear dentro de las líneas. Es para que, en esos momentos de
              crisis, puedas decir:{' '}
              <em data-id="element-20">"Trae a tu Monstruo del Fuego, vamos a darle color".</em>
            </p>
            <p data-id="element-21">
              Es una invitación a conectar, a validar sus raíces bilingües y a
              recuperar la paz en tu hogar, un crayón a la vez. No estás sola en
              esto. Estamos criando niños fuertes, conscientes y orgullosos de
              su voz en ambos idiomas.
            </p>
          </div>

          <div className="mt-10 text-right" data-id="element-22">
            <p className="font-display text-xl font-bold text-dark" data-id="element-23">
              Con cariño,
            </p>
            <p className="font-body text-dark/60" data-id="element-24">Tu Familia / Your Family</p>
          </div>
        </motion.div>
      </div>
    </section>;
};